import React, { useState } from 'react'
import axios from "axios";
import * as Config from "../Utils/Config";
import { header } from "../Utils/ApiHeader";





export async function BrokerProfile(user_id, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerProfile_info`, user_id, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}



export async function BrokerDeltaExchangeProfile(user_id, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerDeltaProfile_info`, user_id, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}


export async function DeltaexchangeWalletData(user_id, token) {
    try {
        const res = await axios.post(`${Config.base_url}DeltaexchangeWallet`, user_id, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}



export async function Deltaexchangetransactions(user_id, token) {
    try {
        const res = await axios.post(`${Config.base_url}getDeltaTransactiondata`, user_id, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}



export async function DeltaexchangePosition(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}getDeltaPosition`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}


export async function getAllDeltaHoldingPositionsdata(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}getAllDeltaHoldingPositions`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}

// getCoinDCXBalance
export async function getCoinDCXBalance(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}getCoinDCXBalance`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}



export async function getCoincdxPosition(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}getCoinDCXActiveOrders`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}



export async function getCoincdxTransactiondata(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}getCoincdxTransaction`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}


export async function getCoinDCXHoldingsdata(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}getCoinDCXHoldings`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}



export async function BinanceProfile(user_id, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerBinanceProfileInfo`, user_id, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}



export async function BrokerBinanceOpenPositiondata(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerBinanceOpenPosition`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}


export async function BrokerBinanceAccount(user_id, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerBinanceAccountDetails`, user_id, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}


export async function BrokerBinanceSpotAccount(user_id, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerBinanceSpotAccountDetails`, user_id, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}


export async function brokerBinanceHoldingPositionData(user_id, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerBinanceHoldingPosition`, user_id, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}

// Zebpay API
export async function ZebpayProfile(user_id, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerZebPayProfileInfo`, user_id, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }
}

// brokerZebPayWallet
export async function ZebpayWalletdata(user_id, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerZebPayWallet`, user_id, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }
}



export async function BrokerCoinswitchWallet(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerCoinswitchWallet`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}

export async function BrokerCoinswitchFuturesWalletBalance(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerCoinswitchWallet`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}


export async function BrokerCoinswitchCloseOrders(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}BrokerCoinswitchCloseOrders`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}

export async function BrokerCoinswitchOpenPosition(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerCoinswitchOpenPosition`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}


export async function BrokerCoinswitchHoldings(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerCoinswitchHoldings`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}


export async function BrokerCoinswitchTransactions(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}brokerCoinswitchTransactions`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}



export async function Pi42WalletData(user_id, token) {
    try {
        const res = await axios.post(`${Config.base_url}pi42/wallet`, user_id, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}


// PI42
export async function BrokerPi42tradingon(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}pi42/tradingon`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}

// PI42
export async function BrokerPi42wallet(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}pi42/wallet`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}
// Pi42TransactionHistory
export async function Pi42TransactionHistory(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}pi42/TransactionHistory`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}
// Pi42Positions
export async function Pi42Positions(data, token) {
    try {
        const res = await axios.post(`${Config.base_url}pi42/positions`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}


export async function getMinimumLotSizeWithPrice(data,token) {
    try {
        const res = await axios.post(`${Config.base_url}minimum-lot-size/with-price`, data, {
            headers: header(token),
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err
    }

}